import { StorageService } from '../storage.service';
import { Logger } from '../log/logger';
import { InjectLogger } from '../log/logger-decorator';

export class AbstractApiService {
  @InjectLogger()
  log: Logger;

  constructor(protected storageService: StorageService = null) {}

  protected async getDefaultHeaders(skipAuth: boolean) {
    const headers: any = {};
    headers['Content-Type'] = 'application/json; charset=utf-8';
    headers['Accept'] = 'application/json';
    if (!skipAuth) {
      const token = JSON.parse(localStorage.getItem('USER_TOKEN'));
      if (token) {
        headers['Authorization'] = `Bearer ${token.data}`;
      }
    }
    return headers;
  }

  protected async get(api: string, options: RequestInit = {}, skipAuth = false) {
    options = Object.assign(
      {
        method: 'GET',
        headers: await this.getDefaultHeaders(skipAuth),
      },
      options,
    );
    const response = await fetch(api, options);
    try {
      const contentType = response.headers.get('content-type');
      const contentLength = response.headers.get('content-length');

      if (contentLength === '0') {
        return null; // No content, return null or handle it as desired
      }

      if (contentType && contentType.includes('application/json')) {
        const data = await response.json();
        return data;
      } else {
        // Handle non-JSON response here
        // For example, return the response text as a string
        const text = await response.text();
        return text;
      }
    } catch (error) {
      if (response.ok) {
        console.log('An unexpected error has occurred:', error);
      } else {
        console.log('HTTP request failed with status:', response.status);
      }
      return null;
    }
  }

  protected async requestForgotPasswordEmail(api: string, options: RequestInit = {}) {
    const response = await fetch(api, options);
    return response;
  }

  protected async getBlob(api: string, options: RequestInit = {}) {
    const response = await fetch(api, options);
    const data = await response.blob();
    return data;
  }

  protected async post(api: string, options: RequestInit = {}, skipAuth = false) {
    return this.postPatchDelete('POST', api, options, skipAuth);
  }

  protected async patch(api: string, options: RequestInit = {}, skipAuth = false) {
    return this.postPatchDelete('PATCH', api, options, skipAuth);
  }

  protected async delete(api: string, options: RequestInit = {}, skipAuth = false) {
    return this.postPatchDelete('DELETE', api, options, skipAuth);
  }

  protected async postPatchDelete(
    method: 'POST' | 'PATCH' | 'DELETE',
    api: string,
    options: RequestInit = {},
    skipAuth = false,
  ) {
    options = Object.assign(
      {
        method: method,
        headers: await this.getDefaultHeaders(skipAuth),
      },
      options,
    );

    const response = await fetch(api, options);
    const data = await response.json();
    return data;
  }
}
